/* global $, API */

import Sortable from 'sortablejs';

const WIDGET_CLASS = '.js-media-browser-widget';
const ADD_CLASS = '.js-media-browser-widget-add';
const ITEM_TEMPLATE_CLASS = '.js-media-browser-item-template';
const LIST_CLASS = '.js-media-input-list';
const ITEM_CLASS = '.js-media-input-item';
const DELETE_CLASS = '.js-media-input-item-delete';

const Widget = {

  /**
   * Initialize widget
   * @param {HTMLElement} node
   * @return {void}
   */
  initialize(node) {
    this.node = node;

    this.itemTemplate = this.getItemTemplate();

    $(WIDGET_CLASS).toArray().forEach((widget) => {
      this.createSortable($(widget));
    });

    $(document).on('click', ADD_CLASS, (e) => {
      const $el = $(e.currentTarget);
      const $widget = this.getWidget($el);
      const id = $widget.data('id');
      this.openBrowser(id);
    });

    $(document).on('click', DELETE_CLASS, (e) => {
      if (window.confirm('Media item verwijderen?')) { // eslint-disable-line no-alert
        const $el = $(e.currentTarget);
        const $item = $el.parents(ITEM_CLASS);
        const $widget = this.getWidget($el);
        this.deleteMedia($widget, $item.data('item-id'));
        this.deleteMediaElement($item);
      }
    });

    $(document).on('browser:selected', (e, obj) => {
      const $widget = this.getWidgetById(obj.id);

      if ($widget.length) {
        this.addMedia($widget, obj.selected);
      }
    });
  },

  /**
   * Get the template for a media item
   * @return {String}
   */
  getItemTemplate() {
    return $(WIDGET_CLASS).find(ITEM_TEMPLATE_CLASS).first().html();
  },

  /**
   * Return the widget element by passing a child of the widget
   * @param {Object} $el
   * @return {Object}
   */
  getWidget($el) {
    return $el.parents(WIDGET_CLASS);
  },

  /**
   * Return a widget given the ID
   * @param {String|Number} id
   * @return {void}
   */
  getWidgetById(id) {
    return $(WIDGET_CLASS).filter(`[data-id="${id}"]`);
  },

  /**
   * Open the media browser
   * @param {String|Number} id
   * @return {void}
   */
  openBrowser(id) {
    $(document).trigger('browser:open', id);
  },

  /**
   * Get media items IDs for widget
   * @param {Object} $widget
   * @return {Array}
   */
  getMediaForWidget($widget) {
    let ids = $widget.find('input[type="hidden"]').val().split(',');
    ids = ids.filter(item => item.length);
    return ids;
  },

  /**
   * Set media items IDs on the widget
   * @param {Object} $widget
   * @param {Array} ids
   * @return {void}
   */
  setMediaForWidget($widget, ids) {
    $widget.find('input[type="hidden"]').val(ids.join(','));
  },

  /**
   * Add media item(s) to the widget
   * @param {Object} $widget
   * @param {Array} ids
   * @return {void}
   */
  addMedia($widget, ids) {
    const currentIds = this.getMediaForWidget($widget);
    const arr = currentIds.concat(ids);

    this.setMediaForWidget($widget, arr);
    this.getMedia(arr)
      .then(data => this.renderMedia($widget, data));
  },

  /**
   * Delete media item by id
   * @param {Object} $widget
   * @param {String|Number} id
   * @return {void}
   */
  deleteMedia($widget, id) {
    let ids = this.getMediaForWidget($widget);

    ids = ids.filter(currentId => (
      parseInt(currentId, 10) !== parseInt(id, 10)
    ));

    this.setMediaForWidget($widget, ids);
  },

  /**
   * Delete media item element
   * @param {Object} $item
   * @return {void}
   */
  deleteMediaElement($item) {
    $item.remove();
  },

  /**
   * Retrieve media items for id
   * @param {Array} ids
   * @return {Promise}
   */
  getMedia(ids) {
    return window.axios.post(API.media.inputListUrl, {
      ids,
    });
  },

  /**
   * Update sort
   * @param {Object} $widget
   * @return {void}
   */
  updateSort($widget) {
    const $items = $widget.find(ITEM_CLASS);

    const ids = $items.toArray().map(item => (
      $(item).data('item-id')
    ));

    this.setMediaForWidget($widget, ids);
  },

  /**
   * Make the widget sortable
   * @param {Object} $widget
   * @return {void}
   */
  createSortable($widget) {
    const el = $widget.find(LIST_CLASS)[0];
    const sortable = Sortable.create(el, {
      onUpdate: () => {
        this.updateSort($widget);
      },
    });

    $widget.data('sortable', sortable);
  },

  /**
   * Render media items
   * @param {Object} $widget
   * @param {Object} data
   * @return {void}
   */
  renderMedia($widget, data) {
    if (typeof $widget.data('sortable') !== 'undefined') {
      const prevSortable = $widget.data('sortable');
      prevSortable.destroy();
    }

    const $list = $widget.find(LIST_CLASS);
    $list.html(data.data);

    this.createSortable($widget);
  },
};

export default Widget;
